import { ACTIVATION_SELECT_ALL } from "./ItemMyStatBase"


export const KEY_GAME_NO = 'game_No'
export const KEY_LEAGUE_ASSOCIATION = 'league_association'
export const KEY_GAME_TYPE = 'game_type'
export const KEY_GAME_ACTIVATION = 'game_activation'
export const KEY_TEAM_NAME = 'team_name'
export const KEY_GAME_DATE = 'game_date'
export const KEY_GAME_DATE_START = 'game_date_start'
export const KEY_GAME_DATE_END = 'game_date_end'
export const KEY_GAME_STATUS = 'game_status'
export const KEY_SCORER = 'scorer'
export const KEY_SCORING_STATUS = 'scoring_status'
export const KEY_GAME_FIELD = 'game_field'
export const KEY_HOME_TEAM = 'home_team'
export const KEY_AWAY_TEAM = 'away_team'
export const KEY_GAME_UMPIRE = 'game_umpire'
export const KEY_GAME_LAST_CHANGE = 'game_last_change'
export const KEY_ISLOCK = 'isLock'

export const KEY_GAME_NO_STRING = '賽程編號'
export const KEY_LEAGUE_ASSOCIATION_STRING = '所屬聯盟'
export const KEY_GAME_TYPE_STRING = '賽事類型'
export const KEY_GAME_ACTIVATION_STRING = '啟停用'
export const KEY_TEAM_NAME_STRING = '參賽球隊'
export const KEY_GAME_DATE_START_STRING = '賽事期間-起'
export const KEY_GAME_DATE_END_STRING = '賽事期間-迄'
export const KEY_GAME_STATUS_STRING = '比賽狀態'
export const KEY_SCORER_STRING = '紀錄員'
export const KEY_SCORING_STATUS_STRING = '紀錄狀態'
export const KEY_GAME_FIELD_STRING = '比賽場地'
export const KEY_HOME_TEAM_STRING = '主場球隊'
export const KEY_AWAY_TEAM_STRING = '客場球隊'
export const KEY_GAME_DATE_STRING = '賽事日期'
export const KEY_GAME_TIME_STRING = '賽事時間'
export const KEY_GAME_UMPIRE_STRING = '主審'
export const KEY_GAME_LAST_CHANGE_STRING = '異動日期'
export const KEY_ISLOCK_STRING = '鎖定'

export const GAME_STATUS_SCHEDULED = 0
export const GAME_STATUS_CANCEL = 1
export const GAME_STATUS_KEEP = 2
export const GAME_STATUS_FINISH = 3

export const GAME_STATUS_SCHEDULED_STRING = "比賽預定"
export const GAME_STATUS_CANCEL_STRING = "比賽取消"
export const GAME_STATUS_KEEP_STRING = "比賽保留"
export const GAME_STATUS_FINISH_STRING = "比賽完成"

export const SCORING_STATUS_NOT_RECORDED= 0
export const SCORING_STATUS_ON_RECORD = 1
export const SCORING_STATUS_UNDER_REVIEW = 2
export const SCORING_STATUS_COMPLETE_REVIEW = 3
export const SCORING_STATUS_RECORD_REVISION = 4

export const SCORING_STATUS_NOT_RECORDED_STRING = "未紀錄"
export const SCORING_STATUS_ON_RECORD_STRING = "紀錄中"
export const SCORING_STATUS_UNDER_REVIEW_STRING = "審查中"
export const SCORING_STATUS_COMPLETE_REVIEW_STRING = "完成審查"
export const SCORING_STATUS_RECORD_REVISION_STRING = "紀錄修正"

export const GAME_TIME_MORNING = 1
export const GAME_TIME_NOON = 2
export const GAME_TIME_AFTERNOON = 3
export const GAME_TIME_EVENING = 4

export const GAME_TIME_MORNING_STRING = "早上場"
export const GAME_TIME_NOON_STRING = "中午場"
export const GAME_TIME_AFTERNOON_STRING = "下午場"
export const GAME_TIME_EVENING_STRING = "晚上場"

export const game_status_only_arr = [
    { val: GAME_STATUS_SCHEDULED, name: GAME_STATUS_SCHEDULED_STRING },
]
export const game_status_arr = [
    { val: GAME_STATUS_SCHEDULED, name: GAME_STATUS_SCHEDULED_STRING },
    { val: GAME_STATUS_CANCEL, name: GAME_STATUS_CANCEL_STRING },
    { val: GAME_STATUS_KEEP, name: GAME_STATUS_KEEP_STRING },
    { val: GAME_STATUS_FINISH, name: GAME_STATUS_FINISH_STRING },
]

export function get_game_status_string(val){
    switch(val){
        case GAME_STATUS_SCHEDULED:
            return GAME_STATUS_SCHEDULED_STRING
        case GAME_STATUS_CANCEL:
            return GAME_STATUS_CANCEL_STRING
        case GAME_STATUS_KEEP:
            return GAME_STATUS_KEEP_STRING
        case GAME_STATUS_FINISH:
            return GAME_STATUS_FINISH_STRING
        default:
            return ""
    }
}

export const scoring_status_only_arr = [
    { val: SCORING_STATUS_NOT_RECORDED, name: SCORING_STATUS_NOT_RECORDED_STRING },
]
export const scoring_status_arr = [
    { val: SCORING_STATUS_NOT_RECORDED, name: SCORING_STATUS_NOT_RECORDED_STRING },
    { val: SCORING_STATUS_ON_RECORD, name: SCORING_STATUS_ON_RECORD_STRING },
    { val: SCORING_STATUS_UNDER_REVIEW, name: SCORING_STATUS_UNDER_REVIEW_STRING },
    { val: SCORING_STATUS_COMPLETE_REVIEW, name: SCORING_STATUS_COMPLETE_REVIEW_STRING },
    { val: SCORING_STATUS_RECORD_REVISION, name: SCORING_STATUS_RECORD_REVISION_STRING },
]

export function get_scoring_status_string(val){
    switch(val){
        case SCORING_STATUS_NOT_RECORDED:
            return SCORING_STATUS_NOT_RECORDED_STRING
        case SCORING_STATUS_ON_RECORD:
            return SCORING_STATUS_ON_RECORD_STRING
        case SCORING_STATUS_UNDER_REVIEW:
            return SCORING_STATUS_UNDER_REVIEW_STRING
        case SCORING_STATUS_COMPLETE_REVIEW:
            return SCORING_STATUS_COMPLETE_REVIEW_STRING
            case SCORING_STATUS_RECORD_REVISION:
                return SCORING_STATUS_RECORD_REVISION_STRING
        default:
            return ""
    }
}

export const game_time_arr = [
    { val: GAME_TIME_MORNING, name: GAME_TIME_MORNING_STRING },
    { val: GAME_TIME_NOON, name: GAME_TIME_NOON_STRING },
    { val: GAME_TIME_AFTERNOON, name: GAME_TIME_AFTERNOON_STRING },
    { val: GAME_TIME_EVENING, name: GAME_TIME_EVENING_STRING },
]

export function get_game_time_string(val){
    switch(val){
        case GAME_TIME_MORNING:
            return GAME_TIME_MORNING_STRING
        case GAME_TIME_NOON:
            return GAME_TIME_NOON_STRING
        case GAME_TIME_AFTERNOON:
            return GAME_TIME_AFTERNOON_STRING
        case GAME_TIME_EVENING:
            return GAME_TIME_EVENING_STRING
        default:
            return ""
    }
}

export class ReqGameList {
    constructor({ start, limit, game_No = "", league_association = "", game_type = "", team_name = "", game_date_start = "", game_date_end = "", scorer = "", game_status = "", scoring_status = "", game_activation = ACTIVATION_SELECT_ALL }) {
        this.start = start
        this.limit = limit
        this.game_No = game_No
        this.league_association = league_association
        this.game_type = game_type
        this.team_name = team_name
        this.game_date_start = game_date_start
        this.game_date_end = game_date_end
        this.scorer = scorer
        this.game_status = game_status
        this.scoring_status = scoring_status
        this.game_activation = game_activation || ACTIVATION_SELECT_ALL
    }

    fromJson(jsonData) {
        this.start = jsonData.start || 0
        this.limit = jsonData.limit || 10
        this.game_No = jsonData.game_No || ""
        this.league_association = jsonData.league_association || ""
        this.game_type = jsonData.game_type || ""
        this.team_name = jsonData.team_name || ""
        this.game_date_start = jsonData.game_date_start || ""
        this.game_date_end = jsonData.game_date_end || ""
        this.scorer = jsonData.scorer || ""
        this.game_status = jsonData.game_status || ""
        this.scoring_status = jsonData.scoring_status || ""
        this.game_activation = jsonData.game_activation
    }

    get_game_activation() {
        return this.game_activation === 1 ? true : false
    }
}

export class ReqGameDetail {
    constructor({game_id}){
        this.game_id = game_id
    }
    fromJson(jsonData){
        this.game_id = jsonData.game_id
    }
}

export class RespGame {
    constructor({game_id, game_No, league_association, game_type, game_field, game_date, game_time, home_team, home_score, away_team, away_score, game_umpire, scorer, game_status, game_activation, scoring_status, game_last_change, isLock}){
        this.game_id = game_id 
        this.game_No = game_No 
        this.league_association = league_association
        this.game_type = game_type 
        this.game_field = game_field
        this.game_date = game_date
        this.game_time = game_time
        this.home_team = home_team 
        this.home_score = home_score
        this.away_team = away_team
        this.away_score = away_score
        this.game_umpire = game_umpire
        this.scorer = scorer
        this.game_status = game_status
        this.game_activation = game_activation 
        this.scoring_status = scoring_status
        this.game_last_change = game_last_change 
        this.isLock = isLock
    }

    fromJson(jsonData){
        this.game_id = jsonData.game_id 
        this.game_No = jsonData.game_No 
        this.league_association = jsonData.league_association
        this.game_type = jsonData.game_type 
        this.game_field = jsonData.game_field
        this.game_date = jsonData.game_date
        this.game_time = jsonData.game_time || 0
        this.home_team = jsonData.home_team 
        this.home_score = jsonData.home_score || -1
        this.away_team = jsonData.away_team
        this.away_score = jsonData.away_score || -1
        this.game_umpire = jsonData.game_umpire
        this.scorer = jsonData.scorer
        this.game_status = jsonData.game_status
        this.game_activation = jsonData.game_activation
        this.scoring_status = jsonData.scoring_status
        this.game_last_change = jsonData.game_last_change 
        this.isLock = jsonData.isLock || false
    }
}
